(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-tel-visual-gallery]').forEach((gallery) => {
      if (gallery.dataset.telVisualReady) return;
      gallery.dataset.telVisualReady = 'true';
      gallery.querySelector('[data-uk-photo="8"]')?.click();
    });
    scope.querySelectorAll('[data-tel-motion-group]').forEach((group) => {
      if (group.dataset.telMotionReady) return;
      group.dataset.telMotionReady = 'true';
      const videos = [...group.querySelectorAll('[data-tel-step-video]')];
      videos.forEach((video) => {
        const button = group.querySelector('[aria-controls="' + video.id + '"]');
        if (!button) return;
        button.hidden = false;
        video.controls = false;
        const update = () => { button.textContent = video.paused ? 'Play step' : 'Pause step'; button.setAttribute('aria-pressed', String(!video.paused)); };
        button.addEventListener('click', () => {
          video.dataset.telUserPaused = String(!video.paused);
          if (video.paused) video.play().catch(update); else video.pause();
        });
        video.addEventListener('play', update);
        video.addEventListener('pause', update);
        update();
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(({ target: video, isIntersecting }) => {
            if (isIntersecting && !reducedMotion.matches && video.dataset.telUserPaused !== 'true') video.play().catch(() => {});
            else video.pause();
          });
        }, { threshold: 0.35 });
        videos.forEach((video) => observer.observe(video));
      }
      reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) videos.forEach((video) => video.pause()); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
